import { ConvexReactClient } from "convex/react";

function requireConvexUrl() {
  const url = process.env.NEXT_PUBLIC_CONVEX_URL;
  if (!url) {
    throw new Error(
      "Convex URL is not configured. Set NEXT_PUBLIC_CONVEX_URL in your environment."
    );
  }
  return url;
}

let convexReactClient: ConvexReactClient | null = null;

export function getConvexReactClient() {
  if (!convexReactClient) {
    convexReactClient = new ConvexReactClient(requireConvexUrl());
  }
  return convexReactClient;
}
